'use client';

import classNames from 'classnames';
import { RoadmapForm } from '@sapientpro/sapientpro-data-models';
import { useState } from 'react';
import styles from './SurveySection.module.scss';
import AnimatedTitle from '../AnimatedTitle';
import SurveyBlock, { TSelectedAnswer } from './SurveyBlock';
import EntitiesSlider from './EntitiesSlider';
import { TEntityItem } from './EntityItem';
import apiClient from '../../apiClient';

const SurveySection = ({ data }: { data: RoadmapForm }) => {
  const [entities, setEntities] = useState<TEntityItem[]>(data.defaultList);

  const fetchEntities = async (selectedAnswers: TSelectedAnswer[]) => {
    if (!selectedAnswers.length) {
      setEntities(data.defaultList);
    } else {
      try {
        const items = selectedAnswers.reduce((result, currentItem) => {
          let answers:string[] = [];

          currentItem.answers.forEach((currentAnswer) => {
            const { type, slug } = currentAnswer;

            if (type && slug) {
              answers.push(JSON.stringify({ type, slug }));
            }
          });

          return [...result, ...answers];
        }, [] as string[]);

        const formattedItems = `[${items.join(',')}]`;

        const query = new URLSearchParams(JSON.parse(JSON.stringify({
          items: formattedItems,
        })));
        const response:TEntityItem[] = await apiClient.get(`homepage-collections/services-cases?${query}`);

        if (response.length) {
          setEntities(response);
        } else {
          setEntities(data.defaultList);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <section className={styles.surveySection}>
      {
        !!data?.title
          && <h2 className={classNames(styles.title, 'header2', 'container', 'home-page')}><AnimatedTitle title={data?.title} /></h2>
      }
      <div className={classNames(styles.content, 'container', 'home-page')}>
        <SurveyBlock
          questions={data.tabs}
          handleAnswersChange={fetchEntities}
        />
        <EntitiesSlider entities={entities} />
      </div>
    </section>
  );
};
export default SurveySection;
